export default "__VITE_ASSET__DsfyQ2h0__"